'use client'

import {useContext, useEffect} from 'react'
import Image from 'next/image'
import Link from 'next/link'
import HeaderAccountDropdown from '@/components/Header/Account/HeaderAccountDropdown'
import HeaderNotification from '@/components/Header/Notifications/HeaderNotification'
import HeaderSearch from '@/components/Header/Search'
import {AuthContext} from '@/context/AuthProvider'
// import {useChatBoxContext} from '@/context/ChatBoxContext'
import Dropdown from 'antd/lib/dropdown/dropdown'
import classNames from 'classnames'

// import {AppContext} from '@/app/layout'

import styles from './Header.module.scss'

type HeaderProps = {
  hasDarkMode?: boolean
}

const Header = ({hasDarkMode}: HeaderProps) => {
  const {isAuthenticated, user} = useContext(AuthContext)
  // const {chatBoxVisible, setChatBoxVisible} = useChatBoxContext()
  const chatBoxClick = () => {
    const chatroom = document.querySelector('body')
    const webPlayer = document.getElementById('webplayer')
    // console.log(chatroom, 'chatroom')
    if (chatroom && webPlayer) {
      if (chatroom.classList.contains('smode')) {
        webPlayer.classList.add('list_open')
      }
    }
  }
  const menuCommonRender = () => (
    <div
      className={classNames([styles.menuBgShadow, styles.menuCommonWrapper])}
    >
      <div className={styles.menuCommonCol}>
        <h4>Nội dung</h4>
        <ul>
          <li>
            <a href="https://www.onlive.vn/channel/game" target="_blank">
              Trò chơi
            </a>
          </li>
          <li>
            <a href="https://www.onlive.vn/channel/sports" target="_blank">
              Thể thao
            </a>
          </li>
          <li>
            <a href="http://esports.onlive.vn/" target="_blank">
              Esports
            </a>
          </li>
        </ul>
      </div>
      <div className={styles.menuCommonCol}>
        <h4>Vật phẩm & ủng hộ</h4>
        <ul>
          <li>
            <a href="http://point.onlive.vn/subscription" target="_blank">
              Đăng ký
            </a>
          </li>
          <li>
            <a href="http://point.onlive.vn/" target="_blank">
              Bóng bay
            </a>
          </li>
          <li>
            <a
              href="https://afevent2.onlive.vn/app/signature_balloon/index.php"
              target="_blank"
            >
              Bóng bay đặc trưng
            </a>
          </li>
          <li>
            <a href="http://point.onlive.vn/quick-view" target="_blank">
              Vật phẩm
            </a>
          </li>
        </ul>
      </div>
      <div className={styles.menuCommonCol}>
        <h4>Dịch vụ</h4>
        <ul>
          <li>
            <a href="http://point.onlive.vn/ong" target="_blank">
              Nạp OnG
            </a>
          </li>
          <li>
            <a href="https://aqua.onlive.vn/" target="_blank">
              Trợ lý điện tử
            </a>
          </li>
          <li>
            <a
              href="https://hotro.onlive.vn/index.php?pt=notice_list"
              target="_blank"
            >
              Hỗ trợ
            </a>
          </li>
        </ul>
      </div>
    </div>
  )

  const menuGameRender = () => (
    <div className={classNames([styles.menuBgShadow, styles.menuGameWrapper])}>
      <div className={classNames([styles.menuCommonCol])}>
        <ul className={styles.gameList}>
          <li>
            <div
              className={styles.gameItem}
              onClick={() => window.open('https://go.vplay.vn/WQRMFVB6')}
            >
              <div className={styles.thumbnail}>
                <img
                  src={
                    process.env.NEXT_PUBLIC_PATH_DOMAIN +
                    'images/icons/gameCenter/Lttq.png'
                  }
                  alt="logo"
                />
              </div>
              <div className={styles.gameTitle}>
                <span>Lục tung Tam quốc</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )

  useEffect(() => {
    const loginUrl = `${process.env.NEXT_PUBLIC_LOGIN_DOMAIN}/afreeca/login.php?szFrom=full&request_uri=${window.location.href}`
    const btnLogin: any = document.querySelector('#btnLogin')
    if (btnLogin) {
      btnLogin.href = loginUrl
    }
  }, [])

  return (
    <>
      <div className={styles.mainHeader}>
        <div className={styles.logoWrap}>
          <Link href="/" className={styles.logo}>
            <img src={`${process.env.NEXT_PUBLIC_URL_LOGO}`} alt="ON Live" />
          </Link>
        </div>
        <div className={styles.btnGroup}>
          {isAuthenticated ? (
            <Dropdown
              dropdownRender={menuGameRender}
              trigger={['click']}
              arrow
              className={styles.hideOnMobile}
            >
              <button
                className={
                  'btn-onlive link icon ' +
                  styles.btnLivestream +
                  ' ' +
                  styles.hideOnMobile
                }
              >
                <img
                  className="game-center-logo"
                  src={
                    process.env.NEXT_PUBLIC_PATH_DOMAIN +
                    'images/header/game_center_logo.gif'
                  }
                  alt=""
                />
                <span className="btnText">Game Center</span>
              </button>
            </Dropdown>
          ) : (
            ''
          )}
          <HeaderSearch />

          <a
            href={'https://dashboard.onlive.vn'}
            aria-label="dashboard.onlive.vn"
            target={'_blank'}
          >
            <button
              className={
                'btn-onlive link icon ' +
                styles.btnLivestream +
                ' ' +
                styles.hideOnMobile
              }
              aria-label="Livestream"
            >
              <img
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/cameraReels.svg'
                }
                alt="Phát Livestream"
              />
              <span className="btnText">Phát Livestream</span>
            </button>
          </a>

          <a
            href="https://point.onlive.vn/"
            target="_blank"
            className={'btn-onlive primary ' + styles.hideOnMobile}
          >
            Mua Bóng
          </a>
          <Dropdown
            dropdownRender={() => <HeaderNotification />}
            trigger={['click']}
            arrow
            placement="bottomRight"
            destroyPopupOnHide
            className={styles.hideOnMobile}
          >
            <button className={styles.btnNotifications}>
              <Image
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN +
                  'images/icons/notification.svg'
                }
                width={24}
                height={24}
                alt="Thông báo"
              />
            </button>
          </Dropdown>
          {isAuthenticated ? (
            <HeaderAccountDropdown user={user} hasDarkMode={hasDarkMode} />
          ) : (
            <a href="#" id="btnLogin" className="btn-onlive secondary">
              Đăng nhập
            </a>
          )}
          <Dropdown
            dropdownRender={menuCommonRender}
            trigger={['click']}
            arrow
            className={styles.hideOnMobile}
          >
            <button className={styles.btnMenu}>
              <Image
                width={24}
                height={24}
                src={
                  process.env.NEXT_PUBLIC_PATH_DOMAIN + 'images/icons/more.svg'
                }
                alt="Menu"
              />
            </button>
          </Dropdown>
          {/* <button
            className={styles.btnNotifications}
            onClick={() => setChatBoxVisible(!chatBoxVisible)}
          >
            <Image
              src={
                chatBoxVisible
                  ? '/images/icons/chat-on.svg'
                  : '/images/icons/chat.svg'
              }
              width={24}
              height={24}
              alt="Chat"
            />
          </button>

          <button
            className={classNames([styles.btnNotifications, styles.btnRec])}
            onClick={() => clickRecList()}
          >
            <Image
              src={
                recommendationType === 'vod' || recommendationType === 'search'
                  ? '/images/icons/menu-on.svg'
                  : '/images/icons/menu.svg'
              }
              width={24}
              height={24}
              alt="Chat"
            />
          </button>
          <button
            className={classNames([styles.btnNotifications, styles.btnRec])}
            onClick={() => clickStar()}
          >
            <Image
              src={
                recommendationType === 'favorite'
                  ? '/images/icons/star-on.svg'
                  : '/images/icons/star.svg'
              }
              width={24}
              height={24}
              alt="Chat"
            />
          </button> */}

          <ul className="view_ctrl">
            <li className="btn_chat">
              <button
                type="button"
                style={{width: '40px', height: '40px'}}
                onClick={chatBoxClick}
              >
                <span>Chatroom</span>
                {/* <img src="/images/icons/show-chat.svg" alt="show chat"/> */}
              </button>
            </li>
            {/* <li className="btn_list">
              <button type="button" style={{width: '40px', height: '40px'}}>
                <span>Stream List</span>
              </button>
            </li>
            <li className="btn_list_bookmark">
              <button type="button" style={{width: '40px', height: '40px'}}>
                <span>Favorites</span>
              </button>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  )
}

export default Header
